import { escapeHtml } from "./escapeHtml";

export type HeaderTokenKey =
  | "clinic_name" | "clinic_cnpj" | "vet_name" | "vet_crmv" | "vet_mapa" | "vet_phone" | "vet_address";

export const HEADER_TOKEN_KEYS: readonly HeaderTokenKey[] = [
  "clinic_name", "clinic_cnpj", "vet_name", "vet_crmv", "vet_mapa", "vet_phone", "vet_address",
];

export type HeaderTokenValues = Partial<Record<HeaderTokenKey, string | null>>;

const TOKEN_SPAN = /<span\b([^>]*)>[^<]*<\/span>/g;

export function resolveHeaderTokens(html: string, values: HeaderTokenValues): string {
  return html.replace(TOKEN_SPAN, (match, attrs: string) => {
    const key = /\bdata-token="([a-z_]+)"/.exec(attrs)?.[1];
    if (!key) return match;
    const value = values[key as HeaderTokenKey];
    if (!value || !value.trim()) return "";
    const escaped = escapeHtml(value.trim());
    const style = /\bstyle="([^"]*)"/.exec(attrs)?.[1];
    return style ? `<span style="${style}">${escaped}</span>` : escaped;
  });
}
